import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

// The module's own entry guard (`nancy:read`); her settings add their own.
export const Route = createFileRoute("/_authenticated/ws/nancy")({
  beforeLoad: ({ context }) => guardRoute(context.me, "nancy"),
  component: Outlet,
});
